import React from 'react';
import c from 'classnames';
import noop from 'lodash/noop';

import useScreen from '@lyearn/core/hooks/useScreen';
import { Close as IconClose } from '@lyearn/icons';
import { BottomSheet, Box, DeprecatedIconButton, Dialog } from '@lyearn/ui';

import { dialogSizeStyles } from './styles';

const DEFAULT_DIALOG_CLASSES = {
  paper: c(
    'relative transform-gpu text-text-primary bg-bg-primary rounded-16 shadow-04 p-0 m-0 flex overflow-hidden',
    dialogSizeStyles,
  ),
};

const DEFAULT_BOTTOM_SHEET_CLASSES = {
  paperAnchorBottom: 'bg-transparent',
};

interface DialogComponentProps {
  children: React.ReactNode;
  onClose: () => void;
  open: boolean;
  onOpen?: () => void;
  classes?: { paper?: string };
}

function DialogComponent(props: DialogComponentProps) {
  const { isDesktop, isTablet } = useScreen();
  const { children, onClose, open, onOpen = noop, classes } = props;

  const renderDialog = () => (
    <Dialog classes={classes ?? DEFAULT_DIALOG_CLASSES} open={open} onClose={onClose}>
      <DeprecatedIconButton
        appearance="secondary"
        className={c('absolute top-20 z-50 p-0 end-0 end-12')}
        shape="pill"
        size="large"
        variant="ghost"
        onClick={onClose}>
        <IconClose />
      </DeprecatedIconButton>
      {children}
    </Dialog>
  );

  const renderBottomSheet = () => (
    <BottomSheet
      classes={DEFAULT_BOTTOM_SHEET_CLASSES}
      open={open}
      onClose={onClose}
      onOpen={onOpen}>
      <Box className="bottom-sheet-content mt-12 mb-20">{children}</Box>
    </BottomSheet>
  );

  if (isDesktop || isTablet) {
    return <>{renderDialog()}</>;
  }
  return <>{renderBottomSheet()}</>;
}

export default DialogComponent;
